export class UnknownSimStatusError extends Error {

    constructor(m?: string) {
        if(!m) {
            m = 'Unknown SIM Status';
        }
        super(m);
    }
}